import { Grid } from "@mui/material";
import { EnrollmentsFilter } from "services/organizationPortalClient";
import ExportEnrollments from "./ExportEnrollments";

type EnrollmentActionsProps = {
  sortField: string;
  sortDescending: boolean;
  filter: EnrollmentsFilter;
};

export default function EnrollmentActions({
  sortField,
  sortDescending,
  filter,
}: Readonly<EnrollmentActionsProps>) {
  return (
    <Grid container columnSpacing={2} wrap="nowrap">
      <Grid item>
        <ExportEnrollments
          sortField={sortField}
          sortDescending={sortDescending}
          filter={filter}
        />
      </Grid>
    </Grid>
  );
}
